<template>
    <div class="page">

        <van-swipe @change="onChange"
                   v-if="reviewFlag"
                   ref="swiper"
                   class="swiper"
                   :touchable="touchable"
                   vertical :loop="false"
                   :show-indicators="false"
                   style="width:100%;height:100%;z-index: 2">
            <van-swipe-item>
                <div class="section section1" :class="{animated: animateClass.page1}">
                    <img src="http://largescreen.cleverplanting.com/staticImg/title.png" class="title" alt="">
                    <div class="btns">
                        <img src="http://largescreen.cleverplanting.com/staticImg/-s-button.png"
                             class="startBtn" @click="toNewPage(1)" alt="">
                        <img src="http://largescreen.cleverplanting.com/staticImg/pointer.png" class="pointer" alt="">
                    </div>
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="section section2" :class="{animated: animateClass.page2}">
                    <ul class="font">
                        <li v-if="content.userCreateDates">
                            <span class="pingfang">{{content.year}}</span>年
                            <span class="pingfang">{{content.month}}</span>月
                            <span class="pingfang">{{content.date}}</span>日，
                        </li>
                        <li>一次偶然的相遇，</li>
                        <li>我与慧植农当家结缘，</li>
                        <!--专家-->
                        <li v-if="content.userRole>1">开启了在农当家的知识分享之旅；</li>
                        <li><span class="pingfang">2020</span>年过去了，</li>
                        <li>我们一起走过了<span class="pingfang">{{content.userPastDays}}</span>天。</li>
                    </ul>
                    <img src="http://largescreen.cleverplanting.com/staticImg/scroll.png" class="scroll" alt="">
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="section section3" :class="{animated: animateClass.page3}">
                    <ul class="font" v-if="content.discernCnt > 1">
                        <li>2020年</li>
                        <li>我在农当家一共使用<span class="pingfang">{{content.discernCnt}}</span>次智能识别</li>
                        <li>最<span>{{content.userRole>1?'关注':'常识别'}}</span>的农作物是{{content.descernTopCrop}}</li>
                        <li>每次识别只需2S</li>
                        <li><span class="pingfang">{{content.discernCnt}}</span>次识别共耗时<span class="pingfang">{{content.descernDuration}}</span></li>
                        <li>科技真的改变了生活！</li>
                    </ul>
                    <!--低于1次识别-->
                    <ul class="font" v-else>
                        <li><span class="pingfang">2020</span>年</li>
                        <li>我还没有在农当家使用过智能识别，</li>
                        <li>下次在田间遇到病虫害，</li>
                        <li>可以用农当家扫一扫，</li>
                        <li>只需2s就能知道农作物病虫害！</li>
                    </ul>
                    <img src="http://largescreen.cleverplanting.com/staticImg/scroll.png" class="scroll" alt="">
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="section section4" :class="{animated: animateClass.page4}">
                    <!--农户-->
                    <ul class="font" v-if="content.userRole === 1">
                        <div v-if="content.quizCnt > 1">
                            <li><span class="pingfang">2020</span>年，</li>
                            <li>我一共发起了<span class="pingfang">{{content.quizCnt}}</span>个农业问题，</li>
                            <li>收获了<span class="pingfang">{{content.quizExpertReplyCnt}}</span>条专业回复，</li>
                            <li>少跑了<span class="pingfang">{{content.saveTimeCnt}}</span>趟农资店</li>
                            <li>生产中遇到的困难真不少，</li>
                            <li>幸好有农当家一直陪在我身边！</li>
                        </div>
                        <!--低于1次回复问答-->
                        <div v-else>
                            <li><span class="pingfang">2020</span>年，</li>
                            <li>我还没有在农当家发起过农业问题，</li>
                            <li>除了拍照识别病虫害，</li>
                            <li>还可以在问答区在线寻求帮助，</li>
                            <li>有老师提供专业农业技术指导哦</li>
                        </div>
                    </ul>
                    <!--专家-->
                    <ul class="font" v-else>
                        <div v-if="content.expertHelpCnt > 1">
                            <li><span class="pingfang">2020</span>年，</li>
                            <li>我共帮助了<span class="pingfang">{{content.expertHelpCnt}}</span>个正在迷茫中的农友，</li>
                            <li>耐心地回复了<span class="pingfang">{{content.expertQuizReplyCnt}}</span>条来自农户的提问，</li>
                            <li>让农户足不出门就获得了专业农业技术指导。</li>
                            <li>农人不易，</li>
                            <li>尽力帮助他们是我和农当家一起选择的坚持。</li>
                        </div>
                        <div v-else>
                            <li><span class="pingfang">2020</span>年，</li>
                            <li>我还没有回复过农友问答，</li>
                            <li>明年我一定要在力所能及的情况下帮助农友，</li>
                            <li>提供专业技术指导。</li>
                        </div>
                    </ul>
                    <img src="http://largescreen.cleverplanting.com/staticImg/scroll.png" class="scroll" alt="">
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="section section5" :class="{animated: animateClass.page5}">
                    <!--大于1位邀请用户-->
                    <ul class="font" v-if="content.pullNewCnt > 1">
                        <li><span class="pingfang">2020</span>年，</li>
                        <li>
                            我共推荐<span class="pingfang">{{content.pullNewCnt}}</span>位好友在线分享交流农业技术
                        </li>
                        <li>传播农业知识。</li>
                    </ul>
                    <!--低于1位邀请用户-->
                    <ul class="font" v-else>
                        <!--农户-->
                        <div v-if="content.userRole === 1">
                            <li><span class="pingfang">2020</span>年，</li>
                            <li>我还没推荐农当家给周围好友。</li>
                            <li>分享让人快乐，</li>
                            <li>这么好的农业APP快推荐给身边农友吧!</li>
                            <li>做职业新农人，我们一直在努力！</li>
                        </div>
                        <!--专家-->
                        <div v-else>
                            <li><span class="pingfang">2020</span>年，</li>
                            <li>我还没推荐农当家给周围好友。</li>
                            <li>让人快乐，</li>
                            <li>这么好的农业APP快推荐给身边农友吧!</li>
                            <li>科技助农需要我们一起努力！快去分享吧！</li>
                        </div>
                    </ul>
                    <img src="http://largescreen.cleverplanting.com/staticImg/scroll.png" class="scroll" alt="">
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="section section6" :class="{animated: animateClass.page6}">
                    <ul class="font">
                        <li><span class="pingfang">2020</span>年，</li>
                        <li>{{content.userRole === 1 ? '我在农业生产中':'我在农技推广服务上'}}，</li>
                        <li>投入了很多心血，</li>
                        <li>在农当家app共活跃<span class="pingfang">{{content.activeCnt}}</span>次，</li>
                        <li>在农当家英雄谱中，</li>
                        <li>排行
                            <span v-if="content.activeRank<500"><span class="pingfang">500+</span>，继续努力！</span>
                            <span v-else><span class="pingfang">{{content.activeRank}}</span>名</span>
                            ，</li>
                        <li>农当家的成长离不开你的支持！</li>
                    </ul>
                    <img src="http://largescreen.cleverplanting.com/staticImg/scroll.png" class="scroll" alt="">
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="section section7" :class="{animated: animateClass.page7}">
                    <div class="container">
                        <img src="http://largescreen.cleverplanting.com/staticImg/-s-title1.png" class="title" alt="">
                        <p class="keyword">{{keywordFont}}</p>
                    </div>
                    <div class="container"></div>
                    <img src="http://largescreen.cleverplanting.com/staticImg/scroll.png" class="scroll" alt="">
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="section section8" :class="{animated: animateClass.page8}">
                    <div class="container">
                        <img src="http://largescreen.cleverplanting.com/staticImg/-s-title2.png" class="title" alt="">
                        <h6 class="subTitle">{{wantFont}}</h6>
                        <ul class="btns">
                            <li class="btn" v-for="item in buttonfont"
                                :key="item.value"
                                @click="handleWant(item.value)">
                                <img :src="item.url" class="btnImg" alt="">
                            </li>
                        </ul>
                    </div>
                    <div class="container"></div>
                    <img src="http://largescreen.cleverplanting.com/staticImg/scroll.png" class="scroll" alt="">
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="section section9" :class="{animated: animateClass.page9}">
                    <ul class="font">
                        <li>亲爱的{{content.userRole===1?'农户':'专家'}}，</li>
                        <li>感谢您在<span class="pingfang">2020</span>年，</li>
                        <li>与我们一路同行，</li>
                        <li>农当家的成长，</li>
                        <li>离不开你的支持和鼓励，</li>
                        <li>让我们携手，</li>
                        <li>共同期许美好的未来。</li>
                    </ul>
                    <div class="btns">
                        <img @click="handleShare"
                             src="http://largescreen.cleverplanting.com/staticImg/-s-button3.png" class="btn"><br/>
                        <img @click="seeAgain"
                             src="http://largescreen.cleverplanting.com/staticImg/-s-button4.png" class="btn">
                    </div>
                </div>
            </van-swipe-item>
        </van-swipe>

        <!--音乐图标-->
        <icon name="yinle" class="music"
              :class="{musicAnimated: !isOff}"
              @click.native.stop="toggleMuisc"></icon>

        <!--音乐控件-->
        <audio class="media-audio" id="audio" preload="auto" loop
               src="http://largescreen.cleverplanting.com/staticImg/music.m4a"></audio>

    </div>
</template>

<script>
    export default {
        data(){
            return{
                pageIndex: 0,
                wantFont:'',
                touchable: true,

                content:{
                    activeCnt: 0,
                    activeRank: 0,
                    descernDuration: null,
                    descernTopCrop: null,
                    discernCnt: 0,
                    expertHelpCnt: 0,
                    expertQuizReplyCnt: 0,
                    pullNewCnt: 0,
                    quizCnt: 0,
                    quizExpertReplyCnt: 0,
                    saveTimeCnt: 0,
                    userCreateDates: null,
                    userPastDays: null,
                    userRole: 1
                },

                buttonfont:[
                    {
                        value:'种好地',
                        url:'http://largescreen.cleverplanting.com/staticImg/-s-zhd.png'
                    },
                    {
                        value:'学农技',
                        url:'http://largescreen.cleverplanting.com/staticImg/-s-xnj.png'
                    },
                    {
                        value:'丰收赚大钱',
                        url:'http://largescreen.cleverplanting.com/staticImg/-s-zdq.png'
                    },
                    {
                        value:'默默奉献',
                        url:'http://largescreen.cleverplanting.com/staticImg/-s-mmfx.png'
                    },
                    {
                        value:'有钱有闲',
                        url:'http://largescreen.cleverplanting.com/staticImg/-s-yqyx.png'
                    },
                    {
                        value:'不留遗憾',
                        url:'http://largescreen.cleverplanting.com/staticImg/-s-blyh.png'
                    },
                ],
                animateClass:{
                    page1: true,
                    page2: false,
                    page3: false,
                    page4: false,
                    page5: false,
                    page6: false,
                    page7: false,
                    page8: false,
                    page9: false,
                },
                keywordFont:'',
                keywordArr:['丰收触手可及','药到病除','百病不侵','科技助农'],

                reviewFlag: true,  //重新观看
                UserId:'',

                isOff:true,

            }
        },
        created() {
            const {UserId} = this.$route.query || {}
            if(UserId){
                this.getBillInfo(UserId)
                this.UserId = UserId
                this.touchable = true
            }else{
                this.touchable = false
                this.$notify('未查询到用户ID,请重新访问有效链接')
            }
            let index = this.getRandomInt(0,3) //随机数
            this.keywordFont = this.keywordArr[index]
            this.addMusicListen()
        },
        methods:{
            // 获取信息
            getBillInfo(id){
                this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                })
                this.$api.getBillInfo({id}).then(res=>{
                    this.$toast.clear();
                    this.content = { ...res.data}
                    if(this.content.userCreateDates){
                        let temp = this.content.userCreateDates.split('年')
                        this.content.year = temp[0]
                        let monthTemp = temp[1].split('月')
                        this.content.month = monthTemp[0]
                        this.content.date = monthTemp[1].split('日')[0]
                    }
                })
            },
            //分享
            handleShare(){
                this.$router.push({name:'billShareImg', query:{UserId: this.UserId, keywordFont:this.keywordFont}})
            },
            //swiper 定向跳转
            toNewPage(index){
                if(this.touchable){
                    this.$refs.swiper.swipeTo(index);
                }
            },
            //Swipe 索引Change
            onChange(index) {
                this.pageIndex = index
                for(let key in this.animateClass){
                    this.animateClass[key] = false
                }
                this.animateClass['page'+(++index)] = true
            },
            //我想要
            handleWant(value){
                this.wantFont = value
            },
            //再看一次
            seeAgain(){
                this.reviewFlag = false
                this.wantFont = ''
                setTimeout(()=>{
                    this.reviewFlag = true
                },1)
                // this.$refs.swiper.swipeTo(0);
            },
            /**
             * 自动播放音乐效果，解决微信自动播放问题
             */
            addMusicListen(){
                this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                })
                // 自动播放音乐效果，解决微信自动播放问题
                document.addEventListener('touchstart',this.audioAutoPlay,false);
                document.addEventListener('WeixinJSBridgeReady', this.audioAutoPlay,false);
                let oAudio = document.querySelector("#audio");
                if(oAudio.onended){
                    oAudio.onended = function () {//播放完毕，重新循环播放
                        this.$toast.close()
                        oAudio.load();
                        oAudio.play();
                    }
                }
            },
            /**
             * 自动播放音乐
             */
            audioAutoPlay() {
                let audio = document.getElementById('audio');
                this.isOff = false;
                audio.play();
                document.removeEventListener('touchstart',this.audioAutoPlay);
            },
            /**
             * 切换播放/停止音乐
             */
            toggleMuisc(){
                let oAudio = document.querySelector("#audio");
                if(this.isOff){
                    oAudio.play();//让音频文件开始播放
                }else{
                    oAudio.pause();//让音频文件暂停播放
                }
                this.isOff = !this.isOff;
            },
            getRandomInt(min, max) {
                // 以下函数返回 min（包含）～ max（包含）之间的数字：
                return Math.floor(Math.random() * (max - min + 1)) + min
                //  函数返回 min（包含）～ max（不包含）之间的数字
                //  this.data = Math.floor(Math.random() * (max - min) ) + min;
            },
        }
    }
</script>

<style scoped lang="scss">
    @import '@/styles/bill/index';
</style>
